<fcom-button
  *ngIf="showButton$ | async"
  [class]="'login-btn'"
  [finElemTracker]="(loginStatus$ | async) !== LoginStatus.LOGGED_IN ? 'open-login' : 'open-profile'"
  [finElemContext]="trackingContext"
  [finElemType]="ElementTypes.BUTTON"
  [aria]="{
    label:
      ((loginStatus$ | async) !== LoginStatus.LOGGED_IN ? 'login.openLogin' : 'login.displayProfile') | finLocalization,
    role: 'button'
  }"
  [icon]="{
    category: 'svg-library',
    name: (loginStatus$ | async) === LoginStatus.LOGGED_IN ? 'logged-in' : 'single-pax',
    position: IconPosition.LEFT
  }"
  [text]="
    (isMobile$ | async)
      ? ''
      : showName && (loginStatus$ | async) === LoginStatus.LOGGED_IN
        ? (profileName$ | async)
        : showName
          ? ('navigation.login' | finLocalization)
          : ''
  "
  [size]="ButtonSize.S_SMALL"
  [mode]="ButtonMode.INLINE"
  [theme]="ButtonTheme.TERTIARY"
  data-hj-suppress
></fcom-button>
